module.exports = __webpack_public_path__ + "bz.81f2d6419e0debccb767.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/portal/bullseye/node_modules/flag-icon-css/flags/1x1/bz.svg
// module id = ../../../../flag-icon-css/flags/1x1/bz.svg
// module chunks = styles